import {ajax} from "../utils";

//on host virtual page
const initRecommendWinalistButton = () => {
  const recommendWinalistButton = document.getElementById('recommend-winalist');
  const viewAvailableHosts = document.getElementById('view-available-hosts');
  const winalistBlock = document.getElementById('winalist-recommended-block');
  if(recommendWinalistButton && viewAvailableHosts && winalistBlock){
    viewAvailableHosts.classList.add('hidden'); //hide after load (stayed visible for SEO at page load)

    recommendWinalistButton.addEventListener('click', () => {
      //hide/show blocks
      recommendWinalistButton.classList.add('hidden');

      winalistBlock.classList.remove('hidden');
      viewAvailableHosts.classList.remove('hidden');

      //and also send an email to host, saying a visitor wanted to book on Winalist
      let formData = new FormData();
      formData.append('host_id', recommendWinalistButton.dataset.hostId);

      ajax(recommendWinalistButton.dataset.sendEmailUrl, () => {},
      'POST', formData,
      { "X-CSRF-Token": document.cookie.replace(/(?:(?:^|.*;\s*)csrfToken\s*=\s*([^;]*).*$)|^.*$/, "$1") },
      true, false);
    });
  }
}

const initBusinessDeletionRequest = () => {
  const legalRepresentantCheckbox = document.getElementById('legal-representant');
  const onlyLegalRepresentativeContent = document.getElementById('only-legal-representative');
  const formContent = document.getElementById('business-deletion-form-content');
  if(legalRepresentantCheckbox && onlyLegalRepresentativeContent && formContent){
    legalRepresentantCheckbox.addEventListener('change', () => {
      formContent.classList.toggle('hidden');
      onlyLegalRepresentativeContent.classList.toggle('hidden');
    });
  }
}

export { initRecommendWinalistButton, initBusinessDeletionRequest }
